import { Component } from '@angular/core';
import { ColumnHyperlinkDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-hyperlink',
  templateUrl: './ap-column-hyperlink.component.html',
})
export class ApColumnHyperlinkComponent extends ApColumnBase<ColumnHyperlinkDto> {
  load() {
    return;
  }
}
